import { useCallback, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Socket } from 'socket.io-client';
import { CARGO_GET_ONE } from 'api/query-keys';
import type { ICargoInvalidateOneEvent } from './types';
import { ESocketEventName } from './types';

export const useHandleCargoInvalidateOne = (socket: Socket) => {
  const queryClient = useQueryClient();

  const handler = useCallback(
    async (event: ICargoInvalidateOneEvent) => {
      const cargoId = event.payload.cargoId;

      await queryClient.invalidateQueries([CARGO_GET_ONE, cargoId]);
    },
    [queryClient],
  );

  useEffect(() => {
    socket.on(ESocketEventName.cargoInvalidateOne, handler);

    return () => {
      socket.removeListener(ESocketEventName.cargoInvalidateOne, handler);
    };
  }, [handler, socket]);
};
